define('Swissup_Orderattachment/js/view/order/attachment',[
    'jquery',
    'uiComponent',
    'Swissup_Orderattachment/js/order-attachment'
], function ($, Component) {
    'use strict';

    return Component.extend({
        defaults: {
            template: 'Swissup_Orderattachment/order/attachment-markup'
        },

        afterRender: function () {
            $('.swissup-attachment-drag-area').orderAttachment(this.settings);
        }
    });
});

